var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"tech-text",attrs:{"role":"img","aria-label":_vm.text}},[_c('canvas',{ref:"canvas",staticClass:"tech-text__canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }